
// import './App.css';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { GitHub } from './components/GitHub';
import { Home } from './components/Home';
import Navbar from './components/Navbar';
import { Projects } from './components/Projects';
import { Skill } from './components/Skill';
import "./App.css"
import { Contact } from './components/Contact';
import "./ads.txt"



function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <About />
      <Skill />
      <Projects />
      <GitHub />
      <Contact />
      <Footer />
    </div>
  );
}




export default App;
